import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Bonus } from '../lib/bonus';
import { Reaction } from '../lib/reaction';
import { ReactionType } from '../types';

export const useCounterTooltipText = (bonus: Bonus, filter?: ReactionType): string | null => {
	const { t } = useTranslation('common');

	return useMemo(() => {
		if (!bonus.reactions.length) return null;

		const tooltipNamesSet = new Set<string>();

		// filter by reaction param if present
		let reactions;
		if (filter) {
			reactions = bonus.reactions.filter(({ emoji }) => Reaction.fromShortcode(emoji).type === filter);
		} else {
			reactions = bonus.reactions;
		}

		if (!reactions.length) return null;

		// get unique names
		// NOTE: reaction.user_name will be removed when the homepage redesign is fully enabled
		reactions.forEach((reaction) => tooltipNamesSet.add(reaction.user?.display_name ?? reaction.user_name));

		// limit the max names to 10
		const tooltipTextList = Array.from(tooltipNamesSet).slice(0, 10);

		// pushing extra element to break line for 'and n others'
		if (tooltipNamesSet.size > 10) tooltipTextList.push('');

		let text = t('intl_overflow_list', {
			names: [tooltipTextList.join('\n')],
			count: Math.max(tooltipNamesSet.size - 10, 0),
			interpolation: { escapeValue: false },
		});

		// appends the ...
		if (tooltipNamesSet.size > 10) text += '...';
		return text;
	}, [bonus, filter, t]);
};
